export default {
    getPeopleBaseByCardCode (cardCode, man = '1', woman = '0') { // 根据具体字典值调整男女对应值
        let birthday = ''
        let sex = ''
        let age = ''

        function formatBirthday (day) {
            let year = day.substring(0, 4)
            let month = day.substring(4, 6)
            let date = day.substring(6)
            return `${year}-${month}-${date}`
        }

        if (cardCode.length === 15) {
            sex = parseInt(cardCode.charAt(14)) % 2 === 0 ? woman : man
            birthday = formatBirthday("19" + cardCode.substring(6, 12))

        }
        if (cardCode.length === 18) {
            sex = parseInt(cardCode.charAt(16)) % 2 === 0 ? woman : man
            birthday = formatBirthday(cardCode.substring(6, 14))
        }

        if (birthday) {
            let nowDate = new Date()
            let birthdayDate = new Date(birthday)
            age = nowDate.getFullYear() - birthdayDate.getFullYear()
            if (nowDate.getMonth() < birthdayDate.getMonth() || (nowDate.getMonth() === birthdayDate.getMonth() && nowDate.getDate() < birthdayDate.getDate())) {
                age--
            }
        }
        return { sex, age, birthday }
    }
}
